const n = "Agree", o = "Celebrate", e = "Clap", t = "Completed", c = "Sad", s = "Disagree", i = "Funny", r = "Hi", a = "Love", l = "Wow", d = "Angry", g = "Mind blown", p = "On fire", w = "Rich", m = "Sick", y = "Strong", b = {
  agree: n,
  celebrate: o,
  clap: e,
  completed: t,
  sad: c,
  disagree: s,
  funny: i,
  hi: r,
  love: a,
  wow: l,
  angry: d,
  mindBlown: g,
  onFire: p,
  rich: w,
  sick: m,
  strong: y
};
export {
  n as agree,
  d as angry,
  o as celebrate,
  e as clap,
  t as completed,
  b as default,
  s as disagree,
  i as funny,
  r as hi,
  a as love,
  g as mindBlown,
  p as onFire,
  w as rich,
  c as sad,
  m as sick,
  y as strong,
  l as wow
};
